const Footer = () => {
    return (
        <footer className="footer">
            <img src="../images/label.svg" alt="Footer label" className="footer__label" />
        </footer>
    )
}

export default Footer
